var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 43.1998C34.6039 43.1998 43.2 34.6037 43.2 23.9998C43.2 13.3959 34.6039 4.7998 24 4.7998C13.3962 4.7998 4.80005 13.3959 4.80005 23.9998C4.80005 34.6037 13.3962 43.1998 24 43.1998ZM32.8971 20.8969C33.8344 19.9596 33.8344 18.44 32.8971 17.5027C31.9598 16.5655 30.4402 16.5655 29.503 17.5027L21.6 25.4057L18.4971 22.3027C17.5598 21.3655 16.0402 21.3655 15.103 22.3027C14.1657 23.24 14.1657 24.7596 15.103 25.6969L19.903 30.4969C20.8402 31.4341 22.3598 31.4341 23.2971 30.4969L32.8971 20.8969Z",
    fill: "#0DBC9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.bfff79545c379e2328135edd4869811e.svg";
export { ForwardRef as ReactComponent };